import { useWaitingDraftCount } from '@/features/approvals';
import { useWaitingDeskCount } from '@/features/desk';
import type { NavItem } from '../router/navigation';

/** Counts for the menu items that carry one; only fetched when that item is in the menu. */
export function useNavBadges(items: readonly NavItem[]): Record<NonNullable<NavItem['badge']>, number> {
  const desk = useWaitingDeskCount(items.some((i) => i.badge === 'desk')).data ?? 0;
  const approvals = useWaitingDraftCount(items.some((i) => i.badge === 'approvals')).data ?? 0;
  return { desk, approvals };
}
